// Parameters and limits are from Ruuvalli API
export default {
  BUILDING_TYPES: [
    { id: 0, name: 'Kerrostalo', icon: 'apartment' },
    { id: 1, name: 'Omakotitalo', icon: 'home' },
    { id: 3, name: 'Rivitalo', icon: 'shared_house' },
    { id: 4, name: 'Paritalo', icon: 'shared_house' },
  ],
  BUILDING_TYPE: {
    APARTMENT_BUILDING: 0,
    SINGLE_FAMILY_HOUSE: 1,
    ROW_HOUSE: 3,
    SEMI_DETACHED_HOUSE: 4,
  },
  CONDITIONS: [
    { id: 3, name: 'Uusi' },
    { id: 2, name: 'Hyvä' },
    { id: 1, name: 'Tyydyttävä' },
    { id: 0, name: 'Välttävä' },
  ],
  LIMITS: {
    areaMin: 15, // if numRooms > 1 then aparmentArea/numRooms > 5
    areaMax: 400, // if numRooms = 1 then <= 90.0, if numRooms > 1 then aparmentArea/numRooms <= 60
    yearMin: 1600,
    yearMax: new Date().getFullYear() + 1,
    landAreaMin: 100, // landArea > apartmentArea
    landAreaMax: 30000,
    monthlyManagementFeeMin: 10, // if buildingType in (1,4) then monthlyManagementFee / apartmentArea > 0,3
    monthlyManagementFeeMax: 6000, // if buildingType in (1,4) then monthlyManagementFee / apartmentArea < 10
  },
  CONFIDENCE_CLASS_LIMIT: 2,
};
